import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import BenliebAppBase from "../components/BenliebAppBase";
import manageLeadTopicsRoute from '~/shared/routes/manageLeadTopicsRoute';
import confirmNewsletterEmailRoute from '~/shared/routes/confirmNewsletterEmailRoute';

const FourOhFour = React.lazy(() => import('~/shared/layouts/FourOhFour'));
const Home = React.lazy(() => import('../components/pages/Home'));
const Contact = React.lazy(() => import('../components/pages/Contact'));
const Meet = React.lazy(() => import('../components/pages/Meet'));
const TheOldFarmersBall = React.lazy(() => import('../components/pages/TheOldFarmersBall'));
const CallOfMusic = React.lazy(() => import('../components/pages/CallOfMusic'));
const LivingMusicAndDance = React.lazy(() => import('../components/pages/LivingMusicAndDance'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <BenliebAppBase />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        path: "meet",
        element: <Meet />
      },
      {
        path: "pages",
        children: [
          {
            path: "contact",
            element: <Contact />
          },
          {
            path: "the_old_farmers_ball",
            element: <TheOldFarmersBall />
          },
          {
            path: "call_of_music",
            element: <CallOfMusic />
          },
          {
            path: "music_dance",
            element: <LivingMusicAndDance />
          },
        ]
      },
      manageLeadTopicsRoute,
      confirmNewsletterEmailRoute,
    ],
  },
  {
    path: '*',
    element: <FourOhFour />
  }
]);

export default router;